import { useKidsPolicy } from "@/components/features/_hooks/use-kids-policy/use-kids-policy";

import { useProductDayTripPlanFormModelContext } from "../../../../../context";

export const usePlanKidsPolicy = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { kidsPolicy } = viewModel;

	return useKidsPolicy({ kidsPolicy, onSetViewModel });
};
